import React, { useState } from 'react'
import { connect } from "react-redux";
import { Loading } from "../../../redux/action";
import "./brand-data.scss";

import { Grid, TableCell, TableRow } from '@mui/material';
import { SortingColumnsType,TableComponent } from '../../../components/table-component/table';
import { Methods } from "../../../core/utility";
import { DefaultUserProfile } from "../../../config/config";
import { debug } from 'console';
const methods = new Methods();


interface Props {
    UserReducer: any;
    loading: (data: any) => void;
    detailedInfluencer?:any;
    type:any;
  }
 
  
  const influencerTypeRange:any = {
    Nano: "1K - 10K",
    Micro: "10K - 50K",
    "Micro Plus": "50K - 100K",
    Macro: "100K - 500K",
    "Macro Plus": "500K - 1M",
    Mega: "1M - 5M",
    "Mega Plus": "5M+",
  }

const EngagedInfluencerTable: React.FC<Props> = (props: Props) => {
  const [renderData, setRenderData] = useState<any>([]);
  const influencerColors:any = {
    "Nano": "#D379F0",
    "Micro": "#FEB918",
    "Micro Plus": "#288CFF",
    "Macro": "#34E39A",
    "Macro Plus": "#978D58",
    "Mega": "#FF644F",
    "Mega Plus": "#18587A"
  };
  const isBrandOrganic = props?.type !== 'brand_organic';
  const columnDisplayName = {
    influencer_type: "Influencer Type",
    influencer_count: "No. of Influencers",
    record_count: "No. of Posts",
    er_percentage: "ER",
    ...(isBrandOrganic && { total_amount: "Amount Spent" }),
    EMV: "EMV",
  };
  const sortingColumnType: SortingColumnsType[] = [
    {
      name: "influencer_type",
      columnSize: "70px",
    },
    {
      name: "influencer_count",
      columnSize: "50px",
    }, 
        {
      name: "record_count",
      columnSize: "50px",
    },   
  
     {
      name: "er_percentage",
      columnSize: "70px",
    },
    ...(isBrandOrganic ? [{ name: "total_amount", columnSize: "60px" }] : []),
    {
      name: "EMV",
      columnSize: "60px",
    }      
  ];
  return (
    <div className='brand-pulse-influencer-details-table table-spacing-lg mb-3'>

      <Grid item xs={12} sm={12} md={12}>
        <TableComponent
          tableMinWidth={400}
          pagination={false}
          columnDisplayName={columnDisplayName}
          inputDataSource={props.detailedInfluencer}
          orderByColumnName=""
          sortingColumnType={sortingColumnType}
          renderData={props.detailedInfluencer}
          setRenderData={(e: any) => setRenderData(e)}
        >
{props.detailedInfluencer.map((data: any, index: number) => {
  if (!data.influencer_type) return null;

  return (
    <TableRow key={index}>
      <TableCell>
        <div className='d-flex'>
          <span style={{
            width: '20px',
            height: '20px',
            backgroundColor: influencerColors[data.influencer_type] || '#ccc',
            marginRight: '5px'
          }}></span>
          {/* {data.influencer_type} */}
          {data.influencer_type} ({influencerTypeRange[data.influencer_type] || "N/A"})
        </div>
      </TableCell>

      {typeof data?.influencer_count === 'number' && (
        <TableCell>{methods.convertExactNumber(data.influencer_count)}</TableCell>
      )}

      {typeof data?.record_count === 'number' && (
        <TableCell>{methods.convertExactNumber(data.record_count)}</TableCell>
      )}

      <TableCell>
        {typeof data?.er_percentage === 'number' ? `${data.average_er.toFixed(2)}%` : 'N/A'}
      </TableCell>
      {props?.type !== 'brand_organic' &&
        <TableCell>
          {typeof data?.total_amount === 'number'
            ? methods.convertExactNumber(data.total_amount.toFixed(2))
            : 'N/A'}
        </TableCell>
      }
      <TableCell>
        {typeof data?.emv_total === 'number' ? methods.convertExactNumber(data.emv_total) : 'N/A'}
      </TableCell>
    </TableRow>
  );
})}

        </TableComponent>
      </Grid>

    </div>
  )
}

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(EngagedInfluencerTable);

export { connectToRedux as  EngagedInfluencerTable };

